import { z } from "zod";
import { BLOCKED_TYPES, VALIDATION_KEYS as VK } from "@fysaro/shared";

const timeRegex = /^([01]\d|2[0-3]):([0-5]\d)$/;

export const createBlockedSlotSchema = z
  .object({
    professionalId: z.string().uuid(VK.GENERIC.UUID),
    clinicId: z.string().uuid(VK.GENERIC.UUID).optional().nullable(),
    date: z.string().min(1, VK.BLOCKED.INVALID_DATE),
    // 1. Permitimos que sea opcional/null/vací­o al principio
    startTime: z.string().optional().nullable().or(z.literal("")),
    endTime: z.string().optional().nullable().or(z.literal("")),
    type: z.enum(BLOCKED_TYPES),
    description: z.string().min(1, VK.GENERIC.REQUIRED),
  })
  .strict()
  .superRefine((data, ctx) => {
    if (!data.startTime || !timeRegex.test(data.startTime)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: VK.BLOCKED.TIME_FORMAT,
        path: ["startTime"],
      });
    }
    if (!data.endTime || !timeRegex.test(data.endTime)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: VK.BLOCKED.TIME_FORMAT,
        path: ["endTime"],
      });
    }
    if (data.startTime && data.endTime && data.startTime >= data.endTime) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: VK.BLOCKED.TIME_ORDER,
        path: ["endTime"],
      });
    }
  });

  export const updateBlockedSlotSchema = createBlockedSlotSchema

